import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Select, Space, message, Spin } from 'antd';
import { useSelector } from "react-redux";
import axiosInstance from "../../../configurations/axiosInstance/AxiosInstance";
import { useRole } from '../../../configurations/utils/Utils';
import * as Utils from '../../../composants/utils/utils';
import { FormattedMessage } from "react-intl";


export default function AddGallery() {
    useRole([Utils.PERMISSIONS.CREATE_SLIDER.value]);
    const { accessToken } = useSelector(state => state.authUser);
    const [modalAddOpen, setModalAddOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [form] = Form.useForm();
    const [selectedValue, setSelectedValue] = useState(null);
    const openModal = () => {
        form.resetFields();
        setLoading(false);
        setModalAddOpen(true);
        setFile(null);
        setSelectedValue(null);
    }
    const handleSelectChange = (value) => {
        setSelectedValue(value);
    };
    const typeSelect = [
        {
            id: 1,
            value: 'VIDEO',
            name: 'VIDEO',
            extensions: ["mp4", "avi", "mkv", "mov", "wmv", "flv", "webm", "mpeg", "mpg", "3gp"],
            active: true
        },
        {
            id: 2,
            value: 'AUDIO',
            name: 'AUDIO',
            extensions: ["mp3", "wav", "aac", "flac", "ogg", "wma", "m4a", "amr"],
            active: true
        },
        {
            id: 3,
            value: 'IMAGE',
            name: 'IMAGE',
            extensions: ["png", "jpg", "jpeg", "gif", "bmp", "webp", "tiff", "svg", "ico"],
            active: true
        }

    ]

    const selectedType = typeSelect.find(t => t.value === selectedValue);
    const acceptedExtensions = selectedType ? selectedType.extensions.map(ext => `.${ext}`).join(',') : "";

    const onSubmit = (values) => {
        if (file === null) {
            message.error('Choisir le fichier de la gallery');
        } else {
            setLoading(true);
            const dat = {
                title: values.title,
                description: values.description,
                duree: values.duree,
                type: selectedValue,
            };
            const formData = new FormData();
            formData.append('file', file);
            formData.append('jsonData', JSON.stringify(dat));
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            axiosInstance(accessToken).post(
                "api/gallery/save",
                formData, config
            ).then(
                (result) => {
                    message.success('Gallery file created');
                    setTimeout(
                        () => {
                            form.resetFields();
                            setLoading(false);
                            window.location.reload();
                            setModalAddOpen(false);
                        }, 2000
                    )
                }).catch((error) => {
                    setLoading(false);
                    message.error(error.response.data.error);
                });
        }

    };
    const getFiles = (event) => {
        if (event.target.files.length > 0) {
            setFile(event.target.files[0]);
        }
    }

    return (
        <>
            <Button style={{ float: "right" }} onClick={openModal} >
                <i className="fa fa-plus" aria-hidden="true"></i>Ajouter
            </Button>
            <Modal
                title="Creation d'un fichier de la gallery"
                style={{
                    top: 20,
                }}
                width={1000}
                open={modalAddOpen}
                maskClosable={false}
                closable={false}
                footer={[]}
            >
                <Spin spinning={loading}>
                    <Form onFinish={onSubmit} form={form}>
                        <Form.Item
                            label="Title"
                            name="title"
                            rules={
                                [
                                    { required: true, message: 'Veuillez entrer le titre' },
                                    { type: "string", message: "Entrer un nom valide !" }
                                ]}
                            hasFeedback>
                            <Input placeholder="entrer le Titre" />
                        </Form.Item>


                        <Form.Item
                            label="Type"
                            name="frontType">
                            <Select value={selectedValue} onChange={handleSelectChange} placeholder="Selectionner le type de fichier">
                                {
                                    typeSelect.map(value => {
                                        if (value.active) {
                                            return (<Select.Option key={value.id} value={value.value}>{value.name}</Select.Option>)
                                        }
                                    })
                                }

                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="description"
                            name="description">
                            <Input.TextArea placeholder="Veuillez entrer la description" maxLength={255} showCount />
                        </Form.Item>

                        {(selectedValue === 'VIDEO' || selectedValue === 'AUDIO') && (
                            <Form.Item
                                label={<FormattedMessage id="duree" />}
                                name="duree"
                                rules={[{ required: true, message: 'Veuillez entrer la durée' }]}
                            >
                                <Input type="number" min={1} placeholder="Durée en secondes" />
                            </Form.Item>
                        )}
                        {selectedValue && (
                            <Form.Item
                                label="Fichier"
                                hasFeedback>
                                <input type="file" accept={acceptedExtensions} onChange={getFiles} />
                            </Form.Item>
                        )}
                        <Form.Item>
                            <Space style={{ float: 'right' }}>
                                <Button type='primary' htmlType='submit' disabled={loading}>
                                    Submit
                                </Button>
                                <Button danger disabled={loading} onClick={() => setModalAddOpen(false)} >
                                    <i className="fa fa-times" aria-hidden="true"></i> cancel
                                </Button>

                            </Space>
                        </Form.Item>
                    </Form>
                </Spin>
            </Modal>
        </>
    );
}